export default __webpack_public_path__ + "static/media/icon-link-circle-solid.b2ac8084.svg";